import { BaseInternalFormFactory } from "../../base-internal-form/base-internal-form-factory"
import { DashboardProvider } from "./context/dashboard-context"
import { Dashboard } from "./dashboard"

export const DashboardFactory = () => {
    return (
        <BaseInternalFormFactory pageTitle="Dashboard">
            <DashboardProvider>
                <Dashboard />
            </DashboardProvider>
        </BaseInternalFormFactory>
    )
}